import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Grid, Card, CardContent, Typography, Box } from '@mui/material';

const Stats = () => {
    const [stats, setStats] = useState(null);
    const username = localStorage.getItem('username');

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await axios.get(`https://api.typecopy.co.za/api/UserStats/username/${username}`);
                setStats(response.data);
            } catch (error) {
                console.error('Error fetching user stats:', error);
            }
        };

        if (username) {
            fetchStats();
        }
    }, [username]);

    const formatStat = (stat) => (stat ? stat.toFixed(2) : '0.00');

    return (
        <Box
            sx={{
                backgroundImage: 'url(/path/to/your/background-image.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '100vh',
                padding: '20px'
            }}
        >
            <Container>
                <Box display="flex" justifyContent="center" mb={2}>
                    <Typography variant="h4" gutterBottom>
                        {username ? `${username}'s Stats` : 'User Stats'}
                    </Typography>
                </Box>
                <Grid container spacing={2}>
                    {stats ? (
                        <>
                            <Grid item xs={12} sm={6} md={3}>
                                <Card>
                                    <CardContent>
                                        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                                            <Typography variant="body2" color="text.secondary">
                                                Ads Completed
                                            </Typography>
                                            <Typography variant="h6">
                                                {formatStat(stats.adsCompleted)}
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Card>
                                    <CardContent>
                                        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                                            <Typography variant="body2" color="text.secondary">
                                                Average Time Spent
                                            </Typography>
                                            <Typography variant="h6">
                                                {formatStat(stats.averageTimeSpent)}
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Card>
                                    <CardContent>
                                        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                                            <Typography variant="body2" color="text.secondary">
                                                Words Per Minute
                                            </Typography>
                                            <Typography variant="h6">
                                                {formatStat(stats.wordsPerMinute)}
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Card>
                                    <CardContent>
                                        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                                            <Typography variant="body2" color="text.secondary">
                                                Accuracy
                                            </Typography>
                                            <Typography variant="h6">
                                                {formatStat(stats.accuracy)}%
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </>
                    ) : (
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <Typography variant="body2" color="text.secondary">
                                        No stats available.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    )}
                </Grid>
            </Container>
        </Box>
    );
};

export default Stats;